export * from './parcel-shop.component';
